module.exports = __webpack_public_path__ + "static/media/flat2.1deab2f2.jpg";